export default {"src":"/_next/static/media/DPD_Logo.e98f3305.svg","height":79,"width":189};